// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  list(context, date) {
    return new Promise(resolve => {
      NewApiService.get("admin/scheduler/reservations?date="+date)
        .then(({ data }) => {      
          context.commit("set_events", data);
          resolve(data);
        })
    });
  },
  create(context, reservation){
    return new Promise(resolve => {
      NewApiService.post("admin/scheduler/reservations", reservation).
        then(({data}) => {
            context.dispatch("pos/convertOrder", data.order, {root:true})
            resolve(data)
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    })
  },
  
  delete(context, reservationId){
    return new Promise(resolve => {
        NewApiService.delete("admin/scheduler/reservations/"+ reservationId).
        then(({data}) => {
            resolve(data)
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    })
  },
};
